import { forwardRef, useState, useImperativeHandle, useRef } from "react";
import { useTranslation } from "react-i18next";

import { Button, Group, Modal, Text, Title } from "@mantine/core";

export interface IDeleteModalRef {
  close: () => void;
  confirm: () => Promise<boolean>;
}
interface IDeleteModalProps {
  isDeleting: boolean;
}
export const DeleteModal = forwardRef<IDeleteModalRef, IDeleteModalProps>(
  ({ isDeleting }, ref) => {
    const resolveRef = useRef<(confirmed: boolean) => void | null>();
    const [isOpened, setIsOpened] = useState(false);

    const { t } = useTranslation();

    const onClose = () => {
      setIsOpened(false);

      resolveRef.current?.(false);
    };

    useImperativeHandle(ref, () => ({
      close: onClose,
      confirm: async () => {
        setIsOpened(true);
        return await new Promise<boolean>((res) => {
          resolveRef.current = res;
        });
      },
    }));

    return (
      <Modal opened={isOpened} onClose={onClose}>
        <Title mb="sm" size="sm">
          {t("modals.delete.title")}
        </Title>
        <Text color="dimmed" size="sm">
          {t("modals.delete.description")}
        </Text>
        <Group mt="lg" position="right" spacing="xs">
          <Button
            loading={isDeleting}
            onClick={async () => {
              resolveRef.current?.(true);
            }}
          >
            {t("labels.delete")}
          </Button>
          <Button variant="outline" onClick={onClose}>
            {t("labels.cancel")}
          </Button>
        </Group>
      </Modal>
    );
  }
);
